import { Component, OnInit, ViewChild, ChangeDetectionStrategy } from '@angular/core';
import { MatPaginator, MatTableDataSource, MatSort } from '@angular/material';
//import { APIImportPreferenceService } from '../../_services/import-preference/API-import-preference';
import { APIEntityService } from '../../_services/entity/API-entity';
import { BehaviorSubject } from "rxjs/BehaviorSubject";
import { DataSource } from '@angular/cdk/table';
import { Observable } from 'rxjs/Observable';
import { Constants } from '../../../../_utils/Constants';
import { $DBManagerService } from '../../../../_helpers/DB/DBManager.service';
import { FormBuilder, FormGroup } from '@angular/forms';
import { formatDate } from '@angular/common';
import { saveAs as importedSaveAs } from "file-saver";
import { $ModalManagerService } from '../../../../_helpers/Modals/ModalManager.service';
//import { saveAs as importedSaveAs } from "file-saver";   
import * as CryptoJS from 'crypto-js';

import { map } from 'rxjs/operators';

const today = new Date();
var time_today = today.getTime();
let now = new Date();
const currentdat = formatDate(now, 'dd-MM-yyyy', 'en-US', '+0530');
export interface Item {
  value: string;
  viewValue: string;
}
@Component({
  changeDetection:ChangeDetectionStrategy.OnPush,
  selector: 'app-entity-report',
  templateUrl: './entity-report.component.html',
  styleUrls: ['./entity-report.component.css']
})
export class EntityReportComponent implements OnInit {
  today=new Date();
  yesterday:Date=new Date();
  yesterdayDate1=this.yesterday.setDate(this.today.getDate()-1);
  yesterdayDate= formatDate(this.yesterday, 'dd-MM-yyyy', 'en-US'); 
  
   maxDate: Date = new Date();
  public panCard: any = {};
  filterData: any;
  fileDownload: any = [];
  dataSubject = new BehaviorSubject<any[]>([]);
  displayedColumns: string[] = ['Entity_Ref_No', 'Entity_ID', 'Entity_Class', 'E_Org_Name', 'E_Org_Type', 'Entity_Industry', 'Entity_Industry_Other', 'Entity_Sector', 'Entity_Sector_Other', 'POI', 'Entity_AuthSignName', 'Entity_EmailID', 'Entity_Mobile_No', 'Entity_Addr1', 'Entity_POI_Doc', 'Entity_POA_Doc', 'Entity_GST_Doc', 'Entity_GST_Id', 'Entity_SEBI_Doc', 'Entity_Other_Doc', 'Entity_Other_Doc1', 'Reject_Reason', 'Modify_Reason', 'Entity_Status','Entity_Comment', 'Entity_TM_Type', 'Assigned_Timestamp','E_Approve_Date', 'Modified_Count','Blacklist_Option', 'Request_Type','Entity_Creator',"Old_Documents"];
  copydisplayedColumns: string[] = [...this.displayedColumns]; //For Index
  selectedColumns: string[] = [...this.displayedColumns];//For selecting in dropdown by default
  showColumns: Item[] = [
    { value: "Entity_Ref_No", viewValue: "URN" },
    { value: "Entity_ID", viewValue: "Entity ID" },
    { value: "Entity_Class", viewValue: "Entity Classification" },
    { value: "E_Org_Name", viewValue: "Organization Name" },
    { value: "Entity_Industry", viewValue: "Industry Type" },
    { value: 'Entity_Industry_Other', viewValue: "Industry Type Other" },
    { value: "Entity_Sector", viewValue: "Industry Sector" },
    { value: "Entity_Sector_Other", viewValue: "Industry Sector Other" },
    { value: "POI", viewValue: "POI" },
    { value: "Entity_AuthSignName", viewValue: "Authorised Signatory Name" },
    { value: "Entity_EmailID", viewValue: "Registered Email ID" },
    { value: "Entity_Mobile_No", viewValue: "Registered Mobile Number" },
    { value: "Entity_Addr1", viewValue: "Registered Address" },
    { value: "Entity_POI_Doc", viewValue: "POI Document" },
    { value: "Entity_POA_Doc", viewValue: "POA Document" },
    { value: "Entity_GST_Doc", viewValue: "GST Certificate" },
    { value: "Entity_GST_Id", viewValue: "GST ID" },
    { value: "Entity_SEBI_Doc", viewValue: "SEBI Certificate" },
    { value: "Entity_Other_Doc", viewValue: "Other Certificate1" },
    { value: "Entity_Other_Doc1", viewValue: "Other Certificate2" },
    { value: "Reject_Reason", viewValue: "Rejection Reason" },
    { value: "Modify_Reason", viewValue: "Modification Reason" },
    { value: "Entity_Status", viewValue: "Status" },
    { value: "Entity_Comment", viewValue: "Remarks" },
    { value: "Entity_TM_Type", viewValue: "TM Type" },
    { value: "Assigned_Timestamp", viewValue: "Assigned Timestamp" },
    { value: "E_Approve_Date", viewValue: "Action Date" },
    { value: "Modified_Count", viewValue: "Modification Count" },
    { value: "Blacklist_Option", viewValue: "Blacklisted" },

    { value: "Request_Type", viewValue: "Request Type" },
    { value: "Entity_Creator", viewValue: "Creator" },
     { value: "Old_Documents", viewValue: "Old_Documents" },


  ];
  /*  'Uploaded By', */
  form1: any = {};
  fetchedData: any;
  
  noRecord: any;
  selectedTab:any="newRegistration"
  data: any = {"selectedTab":this.selectedTab};
  borderSer: boolean = false;
  borderReg: boolean = false;

  Pan(i, datas) {
    // console.log("datas ",datas);
    const key = '18bcd0b950de300fb873788958fde988fec9b478a936a3061575b16f79977d5b';
    const IV = '2e11075e7b38fa20e192bc7089ccf32b';

    //for(let encrypted of encryptedValues) {
    const decrypted = CryptoJS.AES.decrypt({ ciphertext: CryptoJS.enc.Hex.parse(datas) }, CryptoJS.enc.Hex.parse(key), {
      iv: CryptoJS.enc.Hex.parse(IV),
      mode: CryptoJS.mode.CBC
    });
    //console.log("datas ",decrypted.toString(CryptoJS.enc.Utf8));  
    this.panCard[i] = decrypted.toString(CryptoJS.enc.Utf8);
  }


  onSubmitFilter(filterForm) {

     var fdate = filterForm.startDate;
    var ldate = filterForm.endDate;
    var cdate = filterForm.currentDate;

    cdate = formatDate(Date.now(), 'yyyy-MM-dd', 'en-US');

    if (typeof fdate === 'undefined' || fdate == null)
      fdate = "";
    else
      fdate = formatDate(filterForm.startDate, 'yyyy-MM-dd', 'en-US');
    if (typeof ldate === 'undefined' || ldate == null)
      ldate = "";
    else
      ldate = formatDate(filterForm.endDate, 'yyyy-MM-dd', 'en-US');
    var param = filterForm.search


    if (typeof param === 'undefined' || param == null)
      param = "";
    // else
    //   param = filterForm.search.replace(/\s/g,"");           
  var filterType;

    if (filterForm.searchBy)
      filterType = filterForm.searchBy;

    if (filterForm.search)
      param = filterForm.search

    else if (filterForm.searchBy1)
      param = filterForm.searchBy1

    else if (filterForm.searchBy2)
      param = filterForm.searchBy2

    else if (filterForm.searchBy3)
      param = filterForm.searchBy3

    else if (filterForm.searchBy4)
      param = filterForm.searchBy4
    else if (filterForm.searchBy5)
      param = filterForm.searchBy5
    else 
      param = filterForm.searchBy6


    if (fdate != "" && ldate == "") {
      ldate = cdate
    }


    if ((!filterForm.endDate && !filterForm.search && !filterForm.searchBy && !filterForm.startDate) || filterForm.searchBy == "" && !filterForm.startDate) {
      this.$modal.errorModal({
        title: 'Entity Report',
        msg: 'Please search by valid criteria'
      });
    }
    else if ((filterType != null && filterType != "") && (param == null || param == "")) {

      this.$modal.errorModal({
        title: 'Entity Report',
        msg: 'Please provide ' + filterType + ' value'
      });
    }
    else if (fdate == "" && ldate == "" && (filterType == null || filterType == "") && (param == null || param == "")) {
      this.$modal.errorModal({
        title: 'Entity Report',
        msg: 'Please select any option'
      });
    }
    else if (fdate > ldate) {
      this.$modal.errorModal({
        title: 'Entity Report',
        msg: 'From Date cannot be after To Date'
      });
    }

    else if (fdate == "" && ldate != "") {
      this.$modal.errorModal({
        title: 'Entity Report',
        msg: 'Please select Start date'
      });
    }
    else {
      this.data = {

        "Start_Date": fdate,
        "End_Date": ldate,
        "filterType": filterType,
        "param": param,
        "selectedTab":this.selectedTab
      }

      this.imp.getReportSummaryFilter(this.data)
        .subscribe(r => {

          this.fetchedData = JSON.stringify(r.Data);
          this.dataSource = r.Data;
          this.onChangeDataSource(r.Data);
        });
    }
  }
  openDropdown(value) {
    this.form1.searchBy1=null;
    this.form1.searchBy2=null
    this.form1.searchBy3=null
    this.form1.searchBy4=null
    this.form1.searchBy5=null
    this.form1.searchBy6=null
    this.form1.search=null

    


    this.showStatusDropdown = false;
    this.showDropdown = false;
    this.showDropdown2 = false;
    this.showDropdown3 = false;
    this.showDropdown4 = false;
    this.showDropdown5 = false;
    if (value == "Status") {
      this.showStatusDropdown = true;

    } else if (value == "EntityClassification") {
      this.showDropdown = true;

    } else if (value == "TMtype") {
      this.showDropdown2 = true;

    }
    else if (value == "IndustryCategory") {

      this.showDropdown3 = true;
    }
    else if (value == "RequestType") {

      this.showDropdown4 = true;
    }
    else if (value == "Blacklist") {

      this.showDropdown5 = true;
    }
    else {
      this.showStatusDropdown = false;
      this.showDropdown = false;
      this.showDropdown2 = false;
      this.showDropdown3 = false;
      this.showDropdown4 = false;
      this.showDropdown5 = false;
    }
  }

  showAddress(address) {

    this.$modal.promptModal({
      title: "",
      msg: address
    });
  }



  getSubstring(filename) {
    if (filename)
      return filename.substring(filename.indexOf('.') + 1)
    else
      return
  }
  onChangeTabs(selected){
    console.log("selected tab",selected)
    this.selectedTab=selected
    this.form1={}
    if(selected== "newRegistration"){
      this.borderReg = true;
      this.borderSer = false;
    }else if (selected == "serviceLogs"){
      this.borderSer=true;
      this.borderReg = false;
    }
    // if(this.selectedTab!=selected){
      this.APIgetEntitySummary(selected);
      console.log("this.selectedTab tab",this.selectedTab)

    // }
  }
  selectAll(event: any) {
    if (event.srcElement) {
      if (event.srcElement.checked == true) {
        var elemenstarray = []
        this.showColumns.forEach(element => {
          elemenstarray.push(element.value);
        })
        this.selectedColumns = elemenstarray;
        this.displayedColumns = this.copydisplayedColumns

      }
      else {
        this.selectedColumns = [];
        this.displayedColumns = [];


      }
    }
    console.log("this.displayedColumns", this.displayedColumns)
    console.log("this.copydisplayedColumns", this.copydisplayedColumns)
    console.log("this.selectedColumns", this.selectedColumns)

  }
  onChangeDataSource(value) {
    this.dataSubject.next(value);
    this.dataSource = new MatTableDataSource();

    this.dataSource = new MatTableDataSource(value);
    this.dataSource.paginator = this.paginator;
    //  this.noRecord = this.dataSource.connect().pipe(map(data => data.length === 0));

    // console.log("dataSource : ", this.dataSource);
  }

  public preferencesummary: any;
  public Entity_ID: any;
  applyFilter(filterValue: string) {
    // console.log("in filter");
    this.dataSource.filter = filterValue.trim().toLowerCase();
  }
  GetDND_COMPLAINTS_TSP: any;
  dataSource: any;
  public reqId: any;
  public ncprFilename: any;
  public reqDate: any;
  public uploadedBy: any;
  public userName: any;
  form: any = {};
  startDate1: any;
  showStatusDropdown: boolean = false
  showDropdown: boolean = false
  showDropdown2: boolean = false
  showDropdown3: boolean = false
  showDropdown4: boolean = false
  showDropdown5: boolean = false
  @ViewChild(MatPaginator) paginator: MatPaginator;

  @ViewChild(MatSort) sort: MatSort;
  constructor(
    private imp: APIEntityService,
    private db: $DBManagerService,
    private fb: FormBuilder,
    private $modal: $ModalManagerService,
  ) {


  }
  preferenceSummary: FormGroup;

  ngOnInit() {

    this.reqId = this.db.get(Constants.SESSSION_STORAGE, Constants.ENTITY_NAME);
    this.userName = this.db.get(Constants.SESSSION_STORAGE, Constants.USER_NAME);
    // this.getEntityWorklist();
    this.APIgetEntitySummary(this.selectedTab);
    // this.dataSource.sort = this.sort;
    this.preferenceSummary = this.fb.group({
      fromDate: [''],
      toDate: [''],
      status: ['']
    });
    //  console.log(this.startDate1)
    this.maxDate.setDate(new Date().getDate());

  }

  APIgetEntitySummary(selectedTab) {
    this.imp.getEntityReport(selectedTab).subscribe({
      next: value => {
        this.dataSubject.next(value);
        this.dataSource = new MatTableDataSource();

        this.dataSource = new MatTableDataSource(value);
        this.dataSource.paginator = this.paginator;
        this.dataSource.sort = this.sort;
        //console.log("dataSource : ", this.dataSource);
      }
    });
  }


  downloadreportcsvfile() {
    // let eId = this.db.get(Constants.SESSSION_STORAGE, Constants.ENTITY_ID);
    var query = {
      //  "Entity_Status": { $in: ["A", "IR", "C", "R","M1","M2"] },   
      data: this.data,
      fields: this.displayedColumns,
      selectedTab:this.selectedTab
    }
    var fileName;
    const currentdat = formatDate(now, 'medium', 'en-US', '+0530');
    this.imp.downloadreportcsvfile(query).subscribe(r => {
      fileName = currentdat + ' Entity Report.csv';
      importedSaveAs(r, fileName)
      //  this.downloadFile(r, Batch_Id);
      this.$modal.successModal({
        title: 'Entity Summary',
        msg: 'File has been downloaded Successfully'
      });
    })

  }

  updateForm(event: any, val) {


    if (event.isUserInput) {
      if (event.source.selected == true) {
        // this.displayedColumns2.push(val);
        var indexofval;
        for (var i = 0; i < this.showColumns.length; i++) {
          if (this.showColumns[i].value == val) {
            indexofval = i
          }
        }
        

        if (indexofval > -1) {
          this.displayedColumns.splice(indexofval, 0, val);
        }

        
      }
      else {
        var index = this.displayedColumns.indexOf(val);
        if (index > -1) {
          this.displayedColumns.splice(index, 1);
        }
      }
    }

  }

  BlacklistEntity(entityid, setFlag) {
    var datajson = {
      "Entity_ID": entityid,
      "BlackList_Status": setFlag,
      "Blacklisted_by": this.db.get(Constants.SESSSION_STORAGE, Constants.ENTITY_ID)
    }
    this.imp.BlacklistEntityReport(datajson).subscribe(result => {
      //this.onChangeDataSource(result);
      console.log("result .. ", result);
      if (result.status === 'success' && setFlag == 'true') {
        this.$modal.successModal({
          title: 'Entity Blacklist',
          msg: 'Entity has been Blacklisted'
        });
        this.APIgetEntitySummary(this.selectedTab);
      }
      else if (result.status === 'success' && setFlag == 'false') {
        this.$modal.successModal({
          title: 'Entity Blacklist',
          msg: 'Entity has been Activated'
        });
        this.APIgetEntitySummary(this.selectedTab);
      }
      else if (result.status === 'failed' && result.blacklisterr && !result.inactiveError ){
        this.$modal.errorModal({
          title: 'Entity Blacklist',
          msg: 'Status update successful. Blacklist/Whitelist failed: ' + result.blacklisterr
        });
      }
      else if (result.status === 'failed' && result.blacklisterr && !result.inactiveError ){
        this.$modal.errorModal({
          title: 'Entity Blacklist',
          msg: 'Blacklist/Whitelist successful. Status update failed: ' + result.inactiveError
        });
      }
      else if (result.status === 'failed' && result.blacklisterr && result.inactiveError ){
        this.$modal.errorModal({
          title: 'Entity Blacklist',
          msg: 'Blacklist/Whitelist failed '+result.blacklisterr+' Status update failed: ' + result.inactiveError
        });
      }
      else {
        this.$modal.errorModal({
          title: 'Entity Blacklist',
          msg: 'Some Error Occured'
        });
      }
    })
  }

  download(Entity_Ref_No, filename, filetype) {
    var data = {
      "Entity_Ref_No": Entity_Ref_No,
      "Folder": filetype,
      "FileName": filename,
    }
    this.imp.reportFileDownload(data).subscribe(r => {
      // console.log("response --- : ", r);
      this.downloadFile(r, filename);
      this.$modal.successModal({
        title: 'Entity Reports',
        msg: 'File has been downloaded Successfully'
      });
    })
    this.fileDownload = [];
  }
  downloadold(file1,entityId,filename){  
  
    var data = {
      "Entity_ID": entityId,
      "FileType": "KYC",
      "FileName": file1
	 // "FileName":this.fileDownload

    } 

  this.imp.download(data).subscribe(r => { 

   console.log("response --- : ",r); 
   
  // for(var i=0;i<this.fileDownload.length;i++){
    this.downloadFile(r, file1);
	//this.downloadFile(r, this.fileDownload[i]);
  // }
    this.$modal.successModal({
      title: 'Entity Reports',
      msg: 'File has been downloaded Successfully'
    });   
  })
  this.fileDownload = []; 
}

  private downloadFile(res: any, filename: string): void {
    const url = window.URL.createObjectURL(res);
    const a = document.createElement('a');
    document.body.appendChild(a);
    a.setAttribute('style', 'display: none');
    a.href = url;
    a.download = filename;
    a.click();
    window.URL.revokeObjectURL(url);
    a.remove();
  }

  downloadDailyReport(){
   
    var yesterday = formatDate(this.yesterday, 'ddMMyyyy', 'en-US');
      let fileName= 'Entity_'+yesterday+'.csv';
      this.imp.downloadDailyReport('Entity').subscribe(r => {
        importedSaveAs(r, fileName)
      })
  }

  onApplyFilter1(filterForm1) {
    // console.log(filterForm1.value);  
  }
  reset() {
    this.data = {"selectedTab":this.selectedTab}
    this.APIgetEntitySummary(this.selectedTab);
    this.showDropdown = false;
    this.showDropdown2 = false;
    this.showDropdown3 = false;
    this.showDropdown4 = false;
    this.showDropdown5 = false;
    this.showStatusDropdown = false;
  }
}


